function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-5-4h48v48H-5z"
}), React.createElement("path", {
  d: "M33.28 21.872c.072-.6.12-1.224.12-1.872 0-.648-.048-1.272-.144-1.872l4.056-3.168c.36-.288.456-.816.24-1.224l-3.84-6.648c-.24-.432-.744-.576-1.176-.432l-4.776 1.92c-1.008-.768-2.064-1.392-3.24-1.872l-.72-5.088c-.072-.48-.48-.816-.96-.816h-7.68c-.48 0-.864.336-.936.816l-.72 5.088c-1.176.48-2.256 1.128-3.24 1.872l-4.776-1.92c-.432-.168-.936 0-1.176.432l-3.84 6.648c-.24.432-.144.936.24 1.224l4.056 3.168c-.096.6-.168 1.248-.168 1.872 0 .624.048 1.272.144 1.872L.688 25.04c-.36.288-.456.816-.24 1.224l3.84 6.648c.24.432.744.576 1.176.432l4.776-1.92c1.008.768 2.064 1.392 3.24 1.872l.72 5.088c.096.48.48.816.96.816h7.68c.48 0 .888-.336.936-.816l.72-5.088c1.176-.48 2.256-1.128 3.24-1.872l4.776 1.92c.432.168.936 0 1.176-.432l3.84-6.648c.24-.432.144-.936-.24-1.224l-4.008-3.168zM19 27.2c-3.96 0-7.2-3.24-7.2-7.2s3.24-7.2 7.2-7.2 7.2 3.24 7.2 7.2-3.24 7.2-7.2 7.2z",
  fill: "#DBDCE2",
  fillRule: "nonzero"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 40
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/account.6915ae72.svg";
export { SvgComponent as ReactComponent };